import { createCrudPage } from './factories/crud-page.js';

export const stripHtml = (/** @type {unknown} */ v) => {
  if (typeof v !== 'string') return '';
  const text = v.replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<').replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"');
  return text.length > 80 ? text.slice(0, 80) + '\u2026' : text;
};

export default createCrudPage({
  title: 'Registration Info',
  basePath: '/reg-info',
  columns: [
    { key: 'intro', label: 'Intro', sortable: true, render: stripHtml },
    { key: 'terms', label: 'Terms', sortable: true, render: stripHtml },
    { key: 'age', label: 'Age', sortable: true, render: stripHtml },
    { key: 'newsletter', label: 'Newsletter', sortable: true, render: stripHtml },
  ],
  fields: [
    { key: 'intro', label: 'Intro', type: 'rich-text' },
    { key: 'terms', label: 'Terms', type: 'rich-text' },
    { key: 'age', label: 'Age', type: 'rich-text' },
    { key: 'newsletter', label: 'Newsletter', type: 'rich-text' },
  ],
  defaultSort: { field: 'terms', dir: 'asc' },
});
